export default __webpack_public_path__ + "static/media/Group514@2x.38c3946c.png";